import { render, staticRenderFns } from "./MediumPieChartLegend.vue?vue&type=template&id=79de09ee"
import script from "./MediumPieChartLegend.vue?vue&type=script&lang=js"
export * from "./MediumPieChartLegend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports